// assets
import { TruckOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

// icons
const icons = {
  TruckOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const promoove = {
  id: 'promoove_parent',
  title: '',
  type: 'group',
  children: [
    {
      id: 'promoove',
      title: <FormattedMessage id="Pro Moove" />,
      type: 'collapse',
      icon: icons.TruckOutlined,
      children: [
        {
          id: 'availableVus',
          title: <FormattedMessage id="Available Vente VUs" />,
          icon: icons.TruckOutlined,
          url: '/available-vente-vu',
          type: 'item'
        },
        {
          id: 'availableFinanceVus',
          title: <FormattedMessage id="Available Finance VUs" />,
          icon: icons.TruckOutlined,
          url: '/available-finance-vu',
          type: 'item'
        }
      ]
    }
  ]
};

export default promoove;
